import postToCart from "./postToCart";

export default class QuickBuySizes {
  constructor(el) {
    this.post = new postToCart();
    this.form = el;
    this.product_id = this.form.dataset.id;
    this.url = this.form.dataset.url;
    this.button = this.form.querySelector("[data-js='quick-buy-atc']");
    this.size_inputs = this.form.querySelectorAll('input[name="variant"]');
    this.qty_inputs = this.form.querySelectorAll('input[name="quantity"]');
    this.variant = this.form.dataset.variant;
    this.qty = 1;
    this.selectCta = this.form.querySelector(
      "[data-js='quick-buy-select-cta']",
    );
    this.sizeIsSelected = false;
  }

  init() {
    // console.log("QuickBuySizes initialized")

    if (this.size_inputs && this.size_inputs.length > 0) {
      this.size_inputs.forEach((input) => {
        input.addEventListener("change", () => this.handleInputChange(input));
      });
    }

    if (this.qty_inputs && this.qty_inputs.length > 0) {
      // console.log("qty inputs", this.qty_inputs);
      this.qty_inputs.forEach((input) => {
        input.addEventListener("change", () => this.handleInputChange(input));
      });
    }

    this.button.addEventListener("click", (e) => this.handleClick(e));
  }

  handleClick(e) {
    e.preventDefault();
    this.post.addToCart(this.product_id, this.qty, this.variant, this.url);
    // console.log("atc clicked", e.target)
  }

  handleInputChange(input) {
    // console.log("input changed", input.value);
    if (this.qty_inputs && this.qty_inputs.length > 0) {
      this.qty = this.form.querySelector(
        'input[name="quantity"]:checked',
      ).value;
    }
    if (this.size_inputs && this.size_inputs.length > 0) {
      this.variant = this.form.querySelector(
        'input[name="variant"]:checked',
      ).value;
    }
    if (this.sizeIsSelected === false) {
      this.sizeIsSelected = true;
      //   console.log(input.value, "size selected first time");
      this.selectCta.classList.add("disabled");
      this.button.classList.remove("disabled");
    } else {
      //   console.log(input.value, "size changed");
    }
  }
}
